<template>
  <div class="wjdc-main">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="指派类型">
              <el-select v-model="searchForm.dAssign" clearable style="width: 100px">
                <el-option label="不指派" :value="0"></el-option>
                <el-option label="全员" :value="1"></el-option>
                <el-option label="指定人员" :value="2"></el-option>
                <el-option label="部门" :value="3"></el-option>
                <el-option label="职位" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加调查任务</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%">
              <el-table-column
                label="问卷标题"
                width="140"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="font-weight: bold">{{scope.row.d_title}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="有效期"
                align="center"
                width="200">
                <template slot-scope="scope">
                  <div v-if="scope.row.d_starttime!=0&&scope.row.d_endtime!=0">{{scope.row.d_starttime}}至{{scope.row.d_endtime}}</div>
                  <div v-if="scope.row.d_starttime==0&&scope.row.d_endtime==0">不限</div>
                </template>
              </el-table-column>
              <el-table-column
                label="指派类型"
                align="center"
                width="120">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.d_assign===0" :disable-transitions="true" size="mini" type="info">不指派</el-tag>
                  <el-tag v-if="scope.row.d_assign===1" :disable-transitions="true" size="mini">全员</el-tag>
                  <el-tag v-if="scope.row.d_assign===2" :disable-transitions="true" size="mini" type="danger">指定人员</el-tag>
                  <el-tag v-if="scope.row.d_assign===3" :disable-transitions="true" size="mini" type="warning">部门</el-tag>
                  <el-tag v-if="scope.row.d_assign===4" :disable-transitions="true" size="mini" type="success">职位</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="添加时间"
                align="center"
                width="200">
                <template slot-scope="scope">
                  <div>{{scope.row.d_time}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="问卷描述"
                align="left"
                min-width="180">
                <template slot-scope="scope">
                  <div>{{scope.row.d_desc}}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="应参与人数"
                align="center"
                fixed="right"
                width="90">
                <template slot-scope="scope">
                  <span style="color: #f56c6c;font-weight: bold;margin-left: 10px"><i class="el-icon-user-solid"></i> {{scope.row.d_should}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="已提交人数"
                align="center"
                fixed="right"
                width="90">
                <template slot-scope="scope">
                  <span style="color: #409eff;font-weight: bold;margin-left: 10px"><i class="el-icon-s-order"></i> {{scope.row.d_already}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="230"
                align="center"
                fixed="right">
                <template slot-scope="scope">
<!--                  <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">编辑</el-button>-->
<!--                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>-->
                  <el-button  size="mini" @click.stop="view(scope.row)" icon="el-icon-search">查看详情</el-button>
                  <el-dropdown size="mini"  @click.stop="editRow(scope.row)" split-button icon="el-icon-edit">
                    <i class="el-icon-edit"></i> 编辑
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="deleteRow(scope.row)" style="color:#F56C6C"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div v-loading="editFormLoading">
        <el-form ref="editForm" size="small" :model="editForm" label-width="80px" style="padding:15px 30px 15px 15px;" :rules="rules">
          <el-form-item label="有效期限制" prop="radio">
            <el-radio v-model="editForm.radio" :label="0">不限</el-radio>
            <el-radio v-model="editForm.radio" :label="1">限制</el-radio>
          </el-form-item>
          <el-form-item label="有效期" prop="timeSE"  v-if="editForm.radio==1">
            <el-date-picker
              v-model="editForm.timeSE"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="有效期起"
              end-placeholder="有效期止">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="调查问卷" prop="rid">
            <ResearchSelect v-model="editForm.rid" :oldrid="editForm.oldrid" :groupid="user.dGroupid" :role="0" :key="researchKey"></ResearchSelect>
          </el-form-item>
          <el-form-item label="指派类型" prop="dAssign">
            <el-radio v-model="editForm.dAssign" :label="0">不指派</el-radio>
            <el-radio v-model="editForm.dAssign" :label="1">全员</el-radio>
            <el-radio v-model="editForm.dAssign" :label="2">指定人员</el-radio>
            <el-radio v-model="editForm.dAssign" :label="3">部门</el-radio>
            <el-radio v-model="editForm.dAssign" :label="4">职位</el-radio>
          </el-form-item>
          <el-form-item label="指定人员" prop="useridData" v-if="editForm.dAssign==2">
            <el-cascader
              style="width: 100%"
              v-model="editForm.useridData"
              :options="deptEmployeeTree"
              :props="{multiple: true}"
              placeholder="试试搜索吧"
              :show-all-levels="false"
              filterable
              clearable></el-cascader>
          </el-form-item>
          <el-form-item label="指派部门" prop="deptidData" v-if="editForm.dAssign==3">
            <el-cascader
              style="width: 100%"
              ref="deptSelect"
              v-model="editForm.deptidData"
              :options="deptTree"
              :props="{multiple: true}"
              placeholder="试试搜索吧"
              :show-all-levels="false"
              filterable
              clearable></el-cascader>
          </el-form-item>
          <el-form-item label="指派职位" prop="positionidData" v-if="editForm.dAssign==4">
            <el-cascader
              style="width: 100%"
              v-model="editForm.positionidData"
              :options="positionTree"
              :key="new Date().getTime()"
              :props="{multiple: true}"
              placeholder="试试搜索吧"
              :show-all-levels="false"
              filterable
              clearable></el-cascader>
          </el-form-item>
          <el-form-item style="text-align: right" >
            <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
            <el-button @click="dialogVisible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog
      title="问卷指派详情"
      :visible.sync="viewVisible"
      width="800px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div v-loading="viewTableLoading">
        <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel" size="mini">导出Excel</el-button>
        <el-table
          size="mini"
          :data="viewData"
          stripe
          style="width: 100%">
          <el-table-column
            label="名称"
            width="120"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-weight: bold">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="是否完成"
            width="140"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag v-if="scope.row.issub===0" :disable-transitions="true" size="mini" type="danger">未提交</el-tag>
              <el-tag v-if="scope.row.issub===1" :disable-transitions="true" size="mini" type="success">已提交</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="完成时间"
            min-width="140"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.time==='1'" style="font-weight: bold">N/A</span>
              <span v-if="scope.row.time!=='1'" style="font-weight: bold">{{scope.row.time}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center">
            <template slot-scope="scope">
              <el-button  v-if="scope.row.issub===1" size="mini" @click.stop="examRecord(scope.row)" icon="el-icon-search">查看详情</el-button>
              <el-button  v-if="scope.row.issub===0" size="mini" icon="el-icon-search" disabled>查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
<!--    <el-dialog-->
<!--      :title="examRecordTitle"-->
<!--      :visible.sync="examRecordVisible"-->
<!--      width="800px"-->
<!--      top="10vh"-->
<!--      :destroy-on-close="true"-->
<!--      :lock-scroll="true"-->
<!--      :append-to-body="true">-->
<!--      <div v-loading="examRecordTableLoading">-->
<!--        <el-table-->
<!--          size="mini"-->
<!--          :data="examRecordData"-->
<!--          stripe-->
<!--          style="width: 100%">-->
<!--          <el-table-column-->
<!--            label="提交时间"-->
<!--            width="140"-->
<!--            align="center"-->
<!--            show-overflow-tooltip>-->
<!--            <template slot-scope="scope">-->
<!--              <span style="font-weight: bold">{{scope.row.time}}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            label="是否提交"-->
<!--            min-width="120"-->
<!--            align="center"-->
<!--            show-overflow-tooltip>-->
<!--            <template slot-scope="scope">-->
<!--              <el-tag v-if="scope.row.issub===0" :disable-transitions="true" size="mini" type="danger">未提交</el-tag>-->
<!--              <el-tag v-if="scope.row.issub===1" :disable-transitions="true" size="mini" type="success">已提交</el-tag>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            label="操作"-->
<!--            width="120"-->
<!--            align="center"-->
<!--            fixed="right">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button   size="mini" @click.stop="examRecordDetail(scope.row)" icon="el-icon-search">查看详情</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--        </el-table>-->
<!--      </div>-->
<!--    </el-dialog>-->
    <el-dialog
      title=""
      :visible.sync="researchPreviewVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div v-loading="researchLoading">
        <h4 align="center">{{ researchAddForm.title }}</h4>
        <div style="width: 100%;text-align: center;color: #666666;margin-bottom: 10px">{{ researchAddForm.desc }}</div>
        <div style="text-align: center;font-size: 12px;color:#9aaabf" >
          <i class="el-icon-info"></i> 说明：
          <span>蓝色代表选中</span>
        </div>
        <div v-for="topic in researchAddForm.topicForm" style="margin-left: 50px">
          <h4><span style="color: #e01222" v-if="topic.isreq===1">*</span>{{ topic.xuhao }}、{{ topic.title }}（
            <span v-if="topic.type===1">单选</span>
            <span v-if="topic.type===2">多选</span>
            <span v-if="topic.type===3">输入框</span>
            <span v-if="topic.type===4">评分</span>
            ,<span v-if="topic.isreq===0">非必填）</span>
            <span v-if="topic.isreq===1">必填）</span>
          </h4>
          <div v-if="topic.type===1">
            <div v-for="option in topic.option" style="margin-top: 20px">
            <span style="font-weight: bold" :style="option.roid===topic.choose?'color: #0099FF':''"><i class="el-icon-circle-check" style="margin-right: 10px"></i>
              {{ option.name }}
            </span>
            </div>
          </div>
          <div v-if="topic.type===2">
            <div v-for="option in topic.option" style="margin-top: 20px">
            <span style="font-weight: bold" :style="topic.chooses.indexOf(option.roid)>=0?'color: #0099FF':''"><i class="el-icon-circle-check" style="margin-right: 10px"></i>
              {{ option.name }}
            </span>
            </div>
          </div>
          <div v-if="topic.type===3">
            <el-input
              v-model="topic.contentScore"
              placeholder="用户填写"
              type="textarea"
              :rows="3"
              disabled
              show-word-limit/>
          </div>
          <div v-if="topic.type===4">
            <el-rate :value="topic.contentScore" disabled></el-rate>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getMyResearchTask,
  editResearchTask,
  getDeptEmployeeTree,
  getDeptTree,
  getResearchAssignData,
  delResearchTask, getResearchTaskDetailZJY, exportViewExcelZJY, getResearchRecordZJY, getResearchSubTwoZJY, getResearchSubOneZJY, getTopicList2ById
} from '@/api/work'
import ResearchSelect from '@/components/ResearchSelect'
import { getPositionTree } from '@/api/pub'
export default {
  name: 'wjdc',
  components: { ResearchSelect },
  computed: {
    user: getUser
  },
  data() {
    return {
      researchLoading: false,
      researchPreviewVisible: false,
      researchAddForm: {
        rid: 0,
        title: '',
        desc: '',
        ispub: '',
        topicForm: []
      },
      topicForm: [{
        xuhao: 0,
        type: 1,
        title: '',
        isreq: 0,
        trueOption: null,
        trueOptions: [],
        choose: null,
        chooses: [],
        contentScore: null,
        option: [{
          name: '',
          roid: ''
        }]
      }],
      // examRecordData: [],
      // examRecordTitle: '',
      // examRecordVisible: false,
      // examRecordTableLoading: false,
      exportLoading: false,
      viewData: [],
      viewVisible: false,
      viewTableLoading: false,
      deptEmployeeTree: [],
      positionTree: [],
      deptTree: [],
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        dAssign: null,
        search: ''
      },
      editTitle: '',
      dialogVisible: false,
      editFormLoading: false,
      eidtLoading: false,
      researchKey: '',
      editForm: {
        useridData: [],
        deptidData: [],
        positionidData: [],
        radio: 0,
        dRtid: '',
        timeSE: [],
        dAssign: 0,
        rid: [],
        oldrid: null
      },
      rules: {
        timeSE: [{ required: true, message: '请选择有效期', trigger: 'change' }],
        rid: [{ required: true, message: '请选择问卷', trigger: 'change' }],
        useridData: [{ required: true, message: '请选择指定人员', trigger: 'change' }],
        deptidData: [{ required: true, message: '请选择指派部门', trigger: 'change' }],
        positionidData: [{ required: true, message: '请选择指派职位', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getData()
    this.selectDeptEmployeeTree()
    this.selectPositionTree()
    this.selectDeptTree()
  },
  methods: {
    examRecordDetail(row) {
      this.researchAddForm.topicForm = []
      this.topicForm = []
      this.researchAddForm.desc = row.researchDesc
      this.researchAddForm.title = row.researchTitle
      let _choose = []
      let _contentScore = []
      const data = {
        rsid: row.rsid
      }
      getResearchSubTwoZJY(data).then(response => {
        _choose = response.data
      }).then(() => {
        getResearchSubOneZJY(data).then(response => {
          _contentScore = response.data
        })
      }).then(() => {
        const data = {
          rid: row.version
        }
        getTopicList2ById(data).then(response => {
          let index = 0
          for (const topic of response.data) {
            this.topicForm.push({
              xuhao: index + 1,
              type: topic.type,
              title: topic.title,
              isreq: topic.isreq,
              choose: null,
              chooses: [],
              contentScore: null,
              optioncount: topic.optioncount,
              option: []
            })
            for (const choose of _choose) {
              if (topic.type === 1) {
                if (topic.rtid === choose.rtid) {
                  this.topicForm[index].choose = choose.roid
                }
              }
              if (topic.type === 2) {
                if (topic.rtid === choose.rtid) {
                  this.topicForm[index].chooses.push(choose.roid)
                }
              }
            }
            for (const contentScore of _contentScore) {
              if (topic.type === 3) {
                if (topic.rtid === contentScore.rtid) {
                  this.topicForm[index].contentScore = contentScore.content
                }
              }
              if (topic.type === 4) {
                if (topic.rtid === contentScore.rtid) {
                  this.topicForm[index].contentScore = contentScore.score
                }
              }
            }
            for (const option of topic.optionList) {
              if (topic.type === 1 || topic.type === 2) {
                this.topicForm[index].option.push({
                  name: option.name,
                  roid: option.roid
                })
              }
            }
            this.researchAddForm.topicForm.push(this.topicForm[index])
            index++
            this.count = index
          }
          this.researchLoading = false
        })
      })
    },
    examRecord(row) {
      this.researchLoading = true
      this.researchPreviewVisible = true
      const data = {
        rtid: row.rtid,
        rid: row.rid,
        userid: row.userid,
        role: 0
      }
      getResearchRecordZJY(data).then(response => {
        this.examRecordDetail(response.data)
      }).catch(() => {
        this.researchLoading = false
        this.researchPreviewVisible = false
      })
    },
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          rtid: this.rtid
        }
        exportViewExcelZJY(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    view(row) {
      this.viewVisible = true
      this.viewTableLoading = true
      this.rtid = row.d_rtid
      const data = {
        rtid: row.d_rtid
      }
      getResearchTaskDetailZJY(data).then(response => {
        this.viewData = response.data
        this.viewTableLoading = false
      }).catch(() => {
        this.viewTableLoading = false
      })
    },
    deleteRow(row) {
      this.$confirm('此操作将永久删除该调查问卷任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          d_rtid: row.d_rtid,
          d_assign: row.d_assign
        }
        delResearchTask(data).then(response => {
          this.getData()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        }).catch(() => {})
      })
    },
    editRow(row) {
      this.editFormLoading = true
      if (row == null) {
        this.editTitle = '添加问卷调查任务'
        this.dialogVisible = true
        this.researchKey = new Date().getTime()
        this.editForm.radio = 0
        this.editForm.dRtid = null
        this.editForm.oldrid = ''
        this.editForm.rid = []
        this.editForm.timeSE = [] // 有效期
        this.editForm.dAssign = 0 // 指派类型
        this.editForm.useridData = [] // 指定人员
        this.editForm.deptidData = [] // 指派部门
        this.editForm.positionidData = [] // 指派职位
        this.editFormLoading = false
      } else {
        if (row.d_assign === 2) {
          const data = {
            dGroupid: this.user.dGroupid,
            rtid: row.d_rtid,
            d_assign: row.d_assign
          }
          getResearchAssignData(data).then(response => {
            this.editForm.useridData = response.data
            this.editForm.deptidData = []
            this.editForm.positionidData = [] // 指派职位
            this.editFormLoading = false
          })
        } else if (row.d_assign === 3) {
          const data = {
            dGroupid: this.user.dGroupid,
            rtid: row.d_rtid,
            d_assign: row.d_assign
          }
          getResearchAssignData(data).then(response => {
            this.editForm.deptidData = response.data
            this.editForm.useridData = []
            this.editForm.positionidData = []
            this.editFormLoading = false
          })
        } else if (row.d_assign === 4) {
          const data = {
            dGroupid: this.user.dGroupid,
            rtid: row.d_rtid,
            d_assign: row.d_assign
          }
          getResearchAssignData(data).then(response => {
            this.editForm.positionidData = response.data
            this.editForm.deptidData = []
            this.editForm.useridData = []
            this.editFormLoading = false
          })
        } else {
          this.editForm.positionidData = []
          this.editForm.deptidData = []
          this.editForm.useridData = []
          this.editFormLoading = false
        }
        this.editTitle = '修改问卷调查任务'
        this.researchKey = new Date().getTime()
        this.dialogVisible = true
        this.editForm.dRtid = row.d_rtid
        let time_SE = []
        if (row.d_starttime !== '0' && row.d_endtime !== '0') {
          this.editForm.radio = 1
          time_SE.push(row.d_starttime) // 有效期起
          time_SE.push(row.d_endtime) // 有效期止
          this.editForm.timeSE = time_SE
        } else {
          this.editForm.radio = 0
          this.editForm.timeSE = []
        }
        this.editForm.dAssign = row.d_assign // 指派类型
        this.editForm.oldrid = row.d_rid
      }
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            let startTime = 0
            let endTime = 0
            if (this.editForm.radio !== 0) {
              startTime = this.editForm.timeSE[0]
              endTime = this.editForm.timeSE[1]
            } else {
              startTime = 0
              endTime = 0
            }
            let _useridData = []
            let _deptidData = []
            let _positionidData = []
            if (this.editForm.dAssign === 2) {
              for (const userlst of this.editForm.useridData) {
                for (const user of userlst) {
                  if (user.indexOf('user@') >= 0) {
                    _useridData.push(user.split('@')[1])
                  }
                }
              }
            } else if (this.editForm.dAssign === 3) {
              for (const d of this.$refs.deptSelect.getCheckedNodes()) {
                _deptidData.push(d.value.split('@')[1])
              }
            } else if (this.editForm.dAssign === 4) {
              for (const poslst of this.editForm.positionidData) {
                if (poslst.length === 3) {
                  _positionidData.push(poslst[2])
                }
              }
            }
            const data = {
              dRtid: this.editForm.dRtid,
              rid: this.editForm.rid.rid,
              dStarttime: startTime,
              dEndtime: endTime,
              dAssign: this.editForm.dAssign,
              dUserid: this.user.dUserid,
              dRole: 0,
              useridData: _useridData.join(','),
              deptidData: _deptidData.join(','),
              positionidData: _positionidData.join(','),
              dGroupid: this.user.dGroupid
            }
            this.eidtLoading = true
            editResearchTask(data).then(response => {
              this.eidtLoading = false
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.getData()
              this.dialogVisible = false
            }).catch(() => {
              this.eidtLoading = false
            })
          }
        })
      }
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        userid: this.user.dUserid,
        role: 0,
        page: this.currentPage,
        limit: this.pageSize,
        dAssign: this.searchForm.dAssign,
        content: this.searchForm.search
      }
      getMyResearchTask(data).then(response => {
        this.tableData = response.data.data
        this.total = response.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    selectDeptEmployeeTree() {
      const data = {
        dGroupid: this.user.dGroupid
      }
      getDeptEmployeeTree(data).then(response => {
        this.deptEmployeeTree = response.data
      }).catch(() => {})
    },
    selectPositionTree() {
      getPositionTree().then(response => {
        this.positionTree = response.data
      })
    },
    selectDeptTree() {
      const data = {
        dGroupid: this.user.dGroupid
      }
      getDeptTree(data).then(response => {
        this.deptTree = response.data
      })
    }
  }
}
</script>

<style scoped>
.wjdc-main{
}
</style>

